// Generated by CoffeeScript 2.7.0
var Vertex;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Ajax from 'libs/ajax.js';

import BaseModel from '../base_model.js';

import UserBoundary from '../user_boundary.js';

import Fieldable from '../concerns/fieldable.js';

import AutomationAgent from './automation/agent.js';

export default Vertex = (function() {
  class Vertex extends BaseModel {
    static new(vertex, graph) {
      if (vertex instanceof this) {
        return vertex.setGraph(graph);
      } else {
        return new this(vertex, graph);
      }
    }

    constructor(attrs, graph) {
      super(attrs);
      this.metadata = _.extend({}, {
        position: {
          x: 0,
          y: 0
        }
      }, attrs.metadata);
      this.settings = _.extend({}, {
        carbon_copy: {
          enable_manual: false
        },
        refuse_mode: 1,
        assign_manually: false,
        comment_present: {
          approve: false,
          refuse: false,
          transfer: false
        },
        duration_threshold: {
          enable_delay: false,
          enable_manual: false,
          value: '',
          enable_business_time: false
        }
      }, attrs.settings);
      this.setGraph(graph);
      this.isInitial = this.type === 'YetAnotherWorkflow::Vertex::Initial';
      this.isFinal = this.type === 'YetAnotherWorkflow::Vertex::Final';
      this.operations = this._mergeOperations(attrs.operations);
      if (_.has(attrs, 'automation_agent')) {
        this.isAutomation = true;
        this.automation_agent = new AutomationAgent(_.extend({}, attrs.automation_agent));
      } else {
        this.isAutomation = false;
        this.user_boundary = new UserBoundary(_.extend({}, attrs.user_boundary, {
          overlord: this
        }));
      }
      this.cc_user_boundary = new UserBoundary(_.extend({}, attrs.cc_user_boundary, {
        overlord: this
      }));
      this.setI18nKey('yaw_vertex');
    }

    setGraph(graph) {
      if (!graph) {
        return this;
      }
      this.graph = graph;
      return this;
    }

    updatePosition(position) {
      return _.extend(this.metadata.position, position);
    }

    getTargets(edges = this.graph.edges) {
      var _edges;
      _edges = _.filter(edges, (edge) => {
        return edge.from === this;
      });
      return _.pluck(_edges, 'to');
    }

    update() {
      if (!(this.isPersisted() && this.graph)) {
        return false;
      }
      this.errors.clear();
      return Ajax.patch(`/admin${this.graph.gid.toPath()}/vertices/${this.id}`, {
        data: {
          vertex: this.toJSON()
        },
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        error: (xhr, status, error) => {
          var error_message;
          this.errors.merge(error);
          error_message = this.errors.fullMessages().join('; ');
          return newAlertify(error_message || '保存失败', {
            type: 'error'
          });
        }
      });
    }

    enableDelete() {
      this.errors.clear();
      if (this.isInitial || this.isFinal) {
        this.errors.add('vertex', '开始节点和结束节点不能删除');
      }
      if (!(this.isPersisted() && this.graph)) {
        this.errors.add('vertex', '未保存的节点删除无效');
      }
      if (!this.errors.isBlank()) {
        return false;
      }
      return true;
    }

    delete() {
      if (!this.enableDelete()) {
        return;
      }
      return Ajax.delete(`/admin${this.graph.gid.toPath()}/vertices/${this.id}`, {
        success: () => {
          return this.deleteSucceeded();
        }
      });
    }

    deleteSucceeded() {
      return this.graph.deleteVertex(this);
    }

    copy(metadata) {
      if (this.isInitial || this.isFinal) {
        return;
      }
      return Ajax.post(`/admin${this.graph.gid.toPath()}/vertices/${this.id}/copy`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: metadata,
        success: (vertex) => {
          return this.graph.insertVertex(vertex);
        }
      });
    }

    getPreviousVerticesUrl() {
      return `/admin${this.graph.gid.toPath()}/vertices/${this.id}/previous_vertices`;
    }

    toJSON() {
      var ref, vertex;
      vertex = super.toJSON();
      vertex.graph_id = (ref = this.graph) != null ? ref.id : void 0;
      if (this.isAutomation) {
        vertex.automation_agent_attributes = this.automation_agent.toJSON();
      } else {
        vertex.user_boundary_attributes = this.user_boundary.toJSON();
      }
      vertex.cc_user_boundary_attributes = this.cc_user_boundary.toJSON();
      return _.omit(vertex, 'graph', '_status', 'user_boundary');
    }

    _getDefaultOperations() {
      if (this.isInitial) {
        return _.omit(this.defaultOperations, 'approve', 'refuse', 'transfer');
      } else if (this.isFinal) {
        return {};
      } else {
        return _.omit(this.defaultOperations, 'stash', 'propose', 'remind', 'cancel');
      }
    }

    _mergeOperations(operations = {}) {
      var default_operations;
      default_operations = this._getDefaultOperations();
      return _.reduce(default_operations, function(memo, value, key) {
        memo[key] = _.extend({}, value, operations[key] || {});
        return memo;
      }, {});
    }

  };

  Vertex.setAttributes([
    {
      name: '',
      alias_name: '',
      type: 'YetAnotherWorkflow::Vertex::Normal',
      _status: 'normal'
    },
    'graph_id',
    'graph',
    {
      field_ids: [],
      user_boundary: {},
      automation_agent: {},
      cc_user_boundary: {},
      operations: {},
      settings: {},
      logic_settings: {},
      push_settings: [],
      metadata: {
        position: {
          x: 0,
          y: 0
        }
      }
    }
  ]);

  Vertex.prototype.defaultOperations = {
    approve: {
      name: '通过',
      enabled: true,
      disabled: true
    },
    refuse: {
      name: '回退',
      enabled: true
    },
    transfer: {
      name: '转交',
      enabled: true
    },
    comment: {
      name: '处理意见',
      enabled: true
    },
    esignature: {
      name: '电子签字',
      enabled: false
    },
    // initial vertex only
    stash: {
      name: '保存',
      enabled: true
    },
    propose: {
      name: '发起',
      disabled: true,
      enabled: true
    },
    remind: {
      name: '催促',
      enabled: true
    },
    cancel: {
      name: '撤销',
      enabled: true
    },
    repropose: {
      name: '再次提交',
      enabled: false
    }
  };

  return Vertex;

}).call(this);

Vertex.assemble(Fieldable);
